import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"
import { createTheme, ThemeProvider } from '@mui/material/styles';


import store from "./store"
import { ConfigProvider } from "antd"
import fa_IR from "antd/locale/fa_IR"

// Import IranSans Font
import "./assets/fonts/iransans/iransans.css"
import '../src/common/stimulsoft.viewer.office2013.whiteblue.css'


// Global styles for font
const globalStyles = document.createElement('style')
globalStyles.innerHTML = `
  * {
    font-family: 'IranSansWeb', 'IranSans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
  }
  
  body {
    font-family: 'IranSansWeb', 'IranSans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  input, textarea, select, button {
    font-family: 'IranSansWeb', 'IranSans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  }
  
  .ant-btn, .ant-input, .ant-select, .ant-picker, .ant-modal, .ant-table, .ant-form, .ant-card, .ant-menu {
    font-family: 'IranSansWeb', 'IranSans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  }
`
document.head.appendChild(globalStyles)

const theme = createTheme({
  direction: 'rtl',
  typography: {
    fontFamily: "'IranSansWeb', 'IranSans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
});


// Ant Design theme configuration with IranSans font
const antdTheme = {
  token: {
    fontFamily: "'IranSansWeb', 'IranSans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    fontSize: 14,
  },
}

const app = (
    <ThemeProvider theme={theme}>
      <ConfigProvider direction="rtl" locale={fa_IR} theme={antdTheme}>
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </ConfigProvider>
    </ThemeProvider>
)

ReactDOM.render(app, document.getElementById("root"))
serviceWorker.unregister()